var React = require('react');

function Dropdown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M7 10l5 5 5-5z","key":1})]);
}

Dropdown.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Dropdown;

Dropdown.default = Dropdown;
